import React, {Component} from 'react';
import Button from 'material-ui/Button';
import Dialog, {
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    withMobileDialog
} from 'material-ui/Dialog';

class LabelTranslationDeleteDialog extends Component {

    render() {
        const {
            label,
            handleSubmit,
            handleRequestClose,
            open
        } = this.props;

        return (
            <Dialog
                open={open}
                onClose={handleRequestClose}
            >
                <DialogTitle>{"Delete Label Translation"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this translation for "{label.display_name}"?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleRequestClose} variant="raised">
                        Cancel
                    </Button>
                    <Button onClick={handleSubmit} variant="raised" color="primary" type="submit" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default withMobileDialog()(LabelTranslationDeleteDialog);


// WEBPACK FOOTER //
// ./src/containers/labels/translations/LabelTranslationDeleteDialog.jsx